<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        AppTitle.u-mb-xm(:title="$t('mantraDesc')" tag="h3")



  section.u-mt-md
    .grid.is-widescreen-6
      .column.u-mb-sm
        AppCardBox
          h4.u-mb-xs {{$t('b1.name')}}
          p.u-mb-ts #[b {{ $t('bank.holder') }}] : {{$t('b1.holder')}}
          p.u-mb-ts #[b {{ $t('bank.num') }}] : {{$t('b1.num')}}
          p.u-mb-ts  #[b {{ $t('bank.branch') }}] : {{$t('b1.branch')}}
          p.u-mb-ts #[b {{ $t('bank.address') }}] : {{$t('b1.address')}}
          p.u-mb-ts #[b {{ $t('bank.swift') }}] : {{$t('b1.swift')}}
          p.u-mb-ts #[b EGP {{$t('bank.iban')}} ] : EG180059001600000100015066061
          p #[b USD {{$t('bank.iban')}} ] : EG880059001600000100015066062

      .column.u-mb-sm
        AppCardBox
          h4.u-mb-xs {{$t('b2.name')}}
          p.u-mb-ts #[b {{ $t('bank.name') }}] : {{$t('b2.person')}}
          p.u-mb-ts #[b {{ $t('bank.holder') }}] : {{$t('b2.holder')}}
          p.u-mb-ts #[b {{ $t('bank.num') }}] : {{$t('b2.num')}}
          p.u-mb-ts  #[b {{ $t('bank.branch') }}] : {{$t('b2.branch')}}
          p.u-mb-ts #[b {{ $t('bank.address') }}] : {{$t('b1.address')}}
          p.u-mb-ts #[b {{ $t('bank.swift') }}] : {{$t('b2.swift')}}
          p.u-mb-ts #[b EGP {{$t('bank.iban')}} ] : EG070059001600000100015070818
          p.u-mb-ts #[b USD {{$t('bank.iban')}} ] : EG770059001600000100015070819
          p.u-mb-ts #[b SAR {{$t('bank.iban')}} ] : EG580059001600000100015628426
          p #[b EUR {{$t('bank.iban')}} ] : EG580059001600000100015628426

      .column.u-mb-sm
        AppCardBox
          h4.u-mb-xs {{$t('b3.name')}}
          p.u-mb-ts #[b {{ $t('bank.name') }}] : {{$t('b3.person')}}
          p.u-mb-ts #[b {{ $t('bank.num') }}] : {{$t('b3.num')}}
          p.u-mb-ts #[b {{ $t('bank.branch') }}] : {{$t('b3.branch')}}
          p.u-mb-ts #[b {{ $t('bank.branch_code') }}] : {{$t('b3.branch_code')}}
          p.u-mb-ts #[b {{ $t('bank.address') }}] : {{$t('b3.address')}}
          p.u-mb-ts #[b {{ $t('bank.swift') }}] : {{$t('b3.swift')}}
          p #[b {{ $t('bank.iban') }}] : {{$t('b3.iban')}}
      .column.u-mb-sm
        AppCardBox
          h4.u-mb-xs {{$t('b5.name')}}
          p.u-mb-ts #[b {{ $t('bank.name') }}] : {{$t('b5.person')}}
          p.u-mb-ts #[b {{ $t('bank.num') }}] : {{$t('b5.num')}}
          p.u-mb-ts #[b {{ $t('bank.branch') }}] : {{$t('b5.branch')}}
          p.u-mb-ts #[b {{ $t('bank.branch_code') }}] : {{$t('b5.branch_code')}}
          p.u-mb-ts #[b {{ $t('bank.address') }}] : {{$t('b3.address')}}
          p.u-mb-ts #[b {{ $t('bank.swift') }}] : {{$t('b5.swift')}}
          p #[b {{ $t('bank.iban') }}] : {{$t('b5.iban')}}
      .column.u-mb-sm
        AppCardBox
          h4.u-mb-xs {{$t('b4.name')}}
          p.u-mb-ts #[b {{ $t('bank.name') }}] : {{$t('b4.person')}}
          p.u-mb-ts #[b {{ $t('bank.phone') }}] : {{$t('b4.phone')}}
          p #[b {{ $t('bank.country') }}] : {{$t('b4.country')}}



  section.u-mt-md.u-mb-md
    .grid.is-widescreen-7.is-desktop-8
      .column
        h4 {{$t('ctaContent')}}

    AppLink(to="/contact" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat banks",
    "pageDesc":"Choose the payment method that suits you best from Baianat different banks",
    "mantra":"Payment |methods",
    "mantraDesc":"Choose the method that |suits you best.",
    "bank":{
      "name":"Name",
      "num":"Account no",
      "iban":"IBAN",
      "branch":"Branch",
      "postal":"Postal Service",
      "governorate":"Governorate",
      "swift":"Swift code",
      "phone":"Phone",
      "country":"Country",
      "holder":"Account holder",
      "address":"Address",
      "branch_code":"Branch code"
    },
    "b1":{
      "name":"Faisal Islamic bank ( Personal account )",
      "person":"Mostafa Makram Mostafa Wahba",
      "holder":"Mostafa Makram Mostafa Wahba ",
      "num":"16005618",
      "branch":"New Damietta City",
      "address":"New Damietta, Damietta, Egypt",
      "iban":"EG180059001600000100015066061",
      "swift":"FIEGEGCXDOM"
    },
    "b2":{
      "name":"Faisal Islamic Bank Egypt",
      "person":"Baianat",
      "holder":"Mostafa Makram Mostafa Wahba ",
      "num":"16010000",
      "branch":"New Damietta City",
      "swift":"FIEGEGCXDOM"
    },
    "b3":{
      "name":"Commercial International Bank (CIB Egypt)",
      "person":"Baianat",
      "address":"92 Central area, New Damietta, Damietta, Egypt",
      "branch_code":"142",
      "num":"100042650824",
      "branch":"New Damietta City",
      "swift":"CIBEEGCX142",
      "iban":"EG040010014200000100042650824"
    },
    "b4":{
      "name":"Western Union",
      "person":"Soud Mohamed Soud Slim",
      "country":"Egypt",
      "phone":"00201004055222"
    },
    "b5":{
      "name":"Commercial International Bank (CIB Egypt) - Personal account",
      "person":"Mostafa Makram Mostafa Wahba",
      "branch_code":"142",
      "num":"100043512263",
      "branch":"New Damietta City",
      "swift":"CIBEEGCX142",
      "iban":"EG050010014200000100043512263"
    },
    "cta":"Notify us about <br> a transfer",
    "ctaContent":"When the payment is complete, kindly notify us with the transferor's name, the bank transferred from and the bank account transferred to by opening a ticket."

  },
  "ar": {
    "pageTitle":"البنوك",
    "pageDesc":"اختار وسيلة الدفع المناسبة التي تتناسب معك من وسط البنوك التي توفرها بيانات.",
    "mantra":"وسائل| الدفع",
    "mantraDesc":"اختر طريقة الدفع| التي تناسبك.",
    "bank":{
      "name":"الاسم",
      "num":"رقم الحساب",
      "iban":"آيبان",
      "branch":"فرع",
      "postal":"خدمة بريد",
      "governorate":"المحافظة",
      "swift":"سويفت كود",
      "phone":"الهاتف",
      "country":"الدولة",
      "holder":"مالك الحساب",
      "address":"العنوان",
      "branch_code":"كود الفرع"
    },
    "b1":{
      "name":"بنك فيصل الإسلامي المصرى ( حساب شخصي)",
      "person":"مصطفى مكرم مصطفى وهبة",
      "holder":"مصطفى مكرم مصطفى وهبة ",
      "branch":"دمياط الجديدة",
      "address":"دمياط الجديدة ، دمياط ، مصر",
      "num":"16005618",
      "iban":"EG180059001600000100015066061",
      "swift":"FIEGEGCXDOM"
    },
    "b2":{
      "name":"بنك فيصل الاسلامي المصري",
      "person":"بيانات",
      "holder":"مصطفى مكرم مصطفى وهبه ",
      "num":"16010000",
      "branch":"مدينة دمياط الجديدة",
      "swift":"FIEGEGCXDOM"
    },
    "b3":{
      "name":"البنك التجارى الدولى (CIB) مصر",
      "person":"بيانات",
      "address": "92 المنطقة المركزية ، دمياط الجديدة ، دمياط ، مصر",
      "branch_code": "142",
      "num":"100042650824",
      "branch":"مدينة دمياط الجديدة",
      "swift":"CIBEEGCX142",
      "iban":"EG040010014200000100042650824"
    },
    "b4":{
      "name":"ويسترن يونيون",
      "person":"سعود محمد سعود سليم",
      "country":"مصر",
      "phone":"00201004055222"
    },
    "b5":{
      "name":"البنك التجارى الدولى (CIB) مصر",
      "person":"مصطفى مكرم مصطفى وهبه",
      "branch_code":"142",
      "num":"100043512263",
      "branch":"مدينة دمياط الجديدة",
      "swift":"CIBEEGCX142",
      "iban":"EG050010014200000100043512263"
    },
    "cta":"أبلغنا بالحوالة",
    "ctaContent":"يُرجى إبلاغنا فور التحويل بالبيانات الخاصة بإسم المحول و رقم حسابه و البنك المحول منه وذلك بإضافة تذكرة في قسم الحوالات ."
  }
}
</i18n>
